/**
 * Upload Queue UI — progress bars with status badges
 * Ported from studio: uses workspace store
 */

import { store } from '../../core/store.js'

/**
 * Render upload queue into a container element.
 * Looks for #wsUploadQueue in the DOM; creates it if missing (appended to stage).
 */
export function renderQueue() {
  let c = document.getElementById('wsUploadQueue')

  // Auto-create container if not in HTML
  if (!c) {
    c = document.createElement('div')
    c.id = 'wsUploadQueue'
    c.className = 'ws-upload-queue'
    const stage = document.querySelector('.stage-body') || document.body
    stage.appendChild(c)
  }

  const uploadQueue = store.getState('uploadQueue') || []

  if (uploadQueue.length === 0) {
    c.classList.add('hidden')
    return
  }

  c.classList.remove('hidden')
  c.innerHTML = uploadQueue
    .map(
      (item) => `
    <div class="queue-item">
      <img src="${item.preview}" class="queue-preview" alt="">
      <div class="queue-info">
        <div class="queue-name">${item.file.name}</div>
        <div class="queue-progress-row">
          <div class="queue-progress"><div class="queue-progress-bar" style="width:${item.progress}%"></div></div>
        </div>
      </div>
      <span class="queue-status ${item.status}">${item.status === 'uploading' ? item.progress + '%' : item.status === 'success' ? 'Done' : item.status === 'error' ? 'Error' : 'Pending'}</span>
    </div>
  `
    )
    .join('')
}

// Subscribe to uploadQueue changes in store
store.subscribe('uploadQueue', () => renderQueue())
